package de.oevbs.kunde.kundenportal2.model.services.contract

import dev.fritz2.core.Lenses
import kotlinx.serialization.Serializable

@Lenses
@Serializable
/**
 * CarContract wird nicht für die Vertragsübersicht verwendet, sondern für die Kfz-Services.
 *
 * */
data class CarContract(
    val contractNumberPm: String = "",  // Es gibt im Vertrag 2 Nummern, diese hier ist die aus PM.
    val branchGroup: String = "",       // z.B. "Personenkraftwagen"
    val licencePlate: String = ""       // Kennzeichen, heißt im bp-crm-service2 additionalLine2
) { companion object }